<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name" >
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
          <span v-if="item.children[0].meta.title=='提示信息'" class="hot">{{unReadNum}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title" :title="item.meta.title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name" :title="child.meta.title">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
              <span v-if="child.meta.title=='提示信息'" class="hot">{{unReadNum}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import { formatHotNumber } from '@/utils'
import { getUnReadNum } from '@/api/notice'
import * as vueBus from '@/utils/vueBus'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  mounted() {
    vueBus.$on(vueBus.eventList.updateUnReadNum, this.updateUnReadNum)
  },
  data() {
    return {
      unReadNum: 0
    }
  },
  created(){
    this.updateUnReadNum();
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    updateUnReadNum() {
      let that = this;
      getUnReadNum().then(response => {
        console.log(response.data)
        that.unReadNum = formatHotNumber(response.data)
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .menu-wrapper {
    /deep/ .el-submenu__title{
      padding-left: 10px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      .el-submenu__icon-arrow {
         right: 15px;
      }
    }
   
    /deep/ .el-submenu {
      &__title,
      &__icon-arrow {
        color: #fff !important;
        border-bottom: 1px solid #3e4d64;
        border-left: 5px solid transparent;
        .hot {
          /*width: 18px;*/
          min-width: 18px;
          height: 18px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          background-color: #f00;
          font-size: 14px;
          border-radius: 50%;
          padding: 0 3px;
        }
      }
      &__icon-arrow {
        border-bottom: 0;
        margin-top: -2px;
      }
    }
    /deep/ .el-menu-item {
      border-bottom: 1px solid #3e4d64;
      color: #fff !important;
      border-left: 5px solid transparent;
      padding-left: 10px !important;
      .hot {
        /*width: 18px;*/
        min-width: 18px;
        height: 18px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #f00;
        font-size: 14px;
        border-radius: 50%;
        padding: 0 3px;
      }
      &.is-active {
        border-left: 5px solid #409eff;
        background: #1f2c3d !important;
      }
    }
    /deep/ .el-submenu .el-menu-item{
      padding-left: 20px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue